import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import {
  getCurrentQuizType,
  getQuizSectionalQuestions
} from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { Spacings } from '@styles/index';
import Question from './Question';
import QuestionsInfo from './QuestionsInfo';
import Summary from '../Common/Summary';
import useSummary from '../Common/useSummary';
import useOngoingSection from '../Common/useOngoingSection';

const Wrapper = styled.div`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const SectionQuestionList = styled.div`
  display: grid;
  gap: ${Spacings.SPACING_6B};
  grid-template-columns: repeat(auto-fill, ${Spacings.SPACING_10B});
`;

const Questions = ({ title, sectionUID }) => {
  const { query } = useRouter();
  const { quizUID } = query;

  const { isSubjective } = useSelectorWithShallowEqual(getCurrentQuizType);
  const { allIds, byId } = useSelectorWithShallowEqual(
    getQuizSectionalQuestions(quizUID, sectionUID)
  );

  const { marked, unanswered, answered } = useSummary(sectionUID);
  const { hasOngoingSectional, isLocked, isCompleted } =
    useOngoingSection(sectionUID);

  const renderQuestionNumber = () => (
    <SectionQuestionList>
      {allIds.map((id) => (
        <Question
          key={id}
          sectionUID={sectionUID}
          questionUID={id}
          isLocked={isLocked}
          rank={byId[id].question_rank}
        />
      ))}
    </SectionQuestionList>
  );

  return (
    <Wrapper>
      <QuestionsInfo
        title={title}
        sectionUID={sectionUID}
        isLocked={isLocked}
        isCompleted={isCompleted}
        hasOngoingSectional={hasOngoingSectional}
      />
      {!isSubjective && (
        <Summary
          answeredLabel={`${answered} answered`}
          markedLabel={`${marked} marked`}
          unansweredLabel={`${unanswered} unanswered`}
        />
      )}
      {renderQuestionNumber()}
    </Wrapper>
  );
};

export default Questions;

Questions.propTypes = {
  title: PropTypes.string.isRequired,
  sectionUID: PropTypes.string.isRequired
};
